import { Separator } from '@/components/ui/separator';
import { ArrowLeftRight, BarChartBig, ChartLineIcon, Table, TimerResetIcon } from 'lucide-react';
import { AccountNav } from './account-nav';
import { BudgetNavLink } from './budget-nav-link';
import { useBudgetId } from '@liquidbudget/common';

const budgetMatchFn = (pathname: string, to: string) => {
  const regex = new RegExp(`^${to}(/\\d{4}/\\d{1,2})?$`);
  return regex.test(pathname);
};

/**
 * BudgetNav
 *
 */
export function BudgetNav() {
  const budgetId = useBudgetId();

  return (
    <>
      <nav className="grid items-start px-2 text-sm font-medium lg:px-4 gap-1 py-2">
        <BudgetNavLink
          to={`/budget/${budgetId}`}
          text="Budget"
          icon={<Table size={16} className="mr-2" />}
          matchFn={budgetMatchFn}
        />

        <BudgetNavLink
          to={`/budget/${budgetId}/reports`}
          text="Reports"
          icon={<BarChartBig size={16} className="mr-2" />}
        />

        <BudgetNavLink
          to={`/budget/${budgetId}/projections`}
          text="Projections"
          icon={<ChartLineIcon size={16} className="mr-2" />}
        />

        <BudgetNavLink
          to={`/budget/${budgetId}/account`}
          text="All Transactions"
          icon={<ArrowLeftRight size={16} className="mr-2" />}
        />

        <BudgetNavLink
          to={`/budget/${budgetId}/recurring-transactions`}
          text="Recurring Transactions"
          icon={<TimerResetIcon size={16} className="mr-2" />}
        />

        <Separator className="my-1" />

        <AccountNav />
      </nav>
    </>
  );
}
